export default "__VITE_ASSET__CoI1xoZv__"